import { render, staticRenderFns } from "./BowGallery.vue?vue&type=template&id=0e508a18&"
import script from "./BowGallery.vue?vue&type=script&lang=js&"
export * from "./BowGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default,BowText: require('/workspace/components/atoms/BowText/BowText.vue').default,BowAnimation: require('/workspace/components/base/BowAnimation/BowAnimation.vue').default,BowWrapper: require('/workspace/components/base/BowWrapper/BowWrapper.vue').default,BowMedia: require('/workspace/components/molecules/BowMedia/BowMedia.vue').default,BowSlide: require('/workspace/components/molecules/BowSlider/BowSlide.vue').default,BowSlider: require('/workspace/components/molecules/BowSlider/BowSlider.vue').default})
